import { useMemo } from 'react';

const SHORT_URL = process.env.NX_SHORT_URL;
export const useShortUrl = () => {
  return useMemo(() => {
    if (SHORT_URL) {
      return SHORT_URL;
    }
    if (typeof window === 'undefined') {
      return 'https://tdmz.io';
    }
    if (window.location.host === 'app.tandemz.io') {
      return 'https://tdmz.io';
    }
    return window.location.origin;
  }, [window]);
};
